var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 65,
    viewBox: "0 0 85 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-180 42 32.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.328,
    height: 38.304,
    fill: "#F7931D",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 15,
    d: "M75.828 57.5l-35-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.536 9.805l15.073 6.119L34.351 26.18l-6.118-15.073a1 1 0 0 1 1.303-1.303z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.8e1bdd2f753c5fabea0a29cb0938ed41.svg";
export { ForwardRef as ReactComponent };